import { render, staticRenderFns } from "./RefillsStockTable.vue?vue&type=template&id=37ddb5f0"
import script from "./RefillsStockTable.vue?vue&type=script&lang=js"
export * from "./RefillsStockTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports